export * from './application.service';
import { ApplicationService } from './application.service';
export * from './application.serviceInterface';
export * from './countriesProvincesAndCities.service';
import { CountriesProvincesAndCitiesService } from './countriesProvincesAndCities.service';
export * from './countriesProvincesAndCities.serviceInterface';
export * from './credential.service';
import { CredentialService } from './credential.service';
export * from './credential.serviceInterface';
export * from './document.service';
import { DocumentService } from './document.service';
export * from './document.serviceInterface';
export * from './geographicalData.service';
import { GeographicalDataService } from './geographicalData.service';
export * from './geographicalData.serviceInterface';
export * from './identity.service';
import { IdentityService } from './identity.service';
export * from './identity.serviceInterface';
export * from './info.service';
import { InfoService } from './info.service';
export * from './info.serviceInterface';
export * from './nia.service';
import { NiaService } from './nia.service';
export * from './nia.serviceInterface';
export * from './oAuth.service';
import { OAuthService } from './oAuth.service';
export * from './oAuth.serviceInterface';
export * from './openID.service';
import { OpenIDService } from './openID.service';
export * from './openID.serviceInterface';
export * from './presentation.service';
import { PresentationService } from './presentation.service';
export * from './presentation.serviceInterface';
export * from './sAML.service';
import { SAMLService } from './sAML.service';
export * from './sAML.serviceInterface';
export * from './sCIM.service';
import { SCIMService } from './sCIM.service';
export * from './sCIM.serviceInterface';
export * from './sSO.service';
import { SSOService } from './sSO.service';
export * from './sSO.serviceInterface';
export * from './subjectWallets.service';
import { SubjectWalletsService } from './subjectWallets.service';
export * from './subjectWallets.serviceInterface';
export * from './temporaryResource.service';
import { TemporaryResourceService } from './temporaryResource.service';
export * from './temporaryResource.serviceInterface';
export * from './ticketing.service';
import { TicketingService } from './ticketing.service';
export * from './ticketing.serviceInterface';
export * from './token.service';
import { TokenService } from './token.service';
export * from './token.serviceInterface';
export * from './user.service';
import { UserService } from './user.service';
export * from './user.serviceInterface';
export const APIS = [ApplicationService, CountriesProvincesAndCitiesService, CredentialService, DocumentService, GeographicalDataService, IdentityService, InfoService, NiaService, OAuthService, OpenIDService, PresentationService, SAMLService, SCIMService, SSOService, SubjectWalletsService, TemporaryResourceService, TicketingService, TokenService, UserService];
